export const FirePerimeterFileMetadataEntry = ({
    title,
    value,
}: {
    title: string
    value: string
}) => {
    return (
        <div className="flex justify-between items-center text-gray-300">
            <small>{title}</small>
            <small className="mono">{value}</small>
        </div>
    )
}
